export class Login {
    Username: string
    Password: string

    constructor() {
        this.Username = "";
        this.Password = "";
    }
}